<script setup lang="ts">
import CheckMarkOutlineIcon from '~/assets/icons/outline/checkmark-outline.svg?component';
import PartnerRakutenSectionHeading from '~/components/organisms/PartnerRakutenSectionHeading/PartnerRakutenSectionHeading.vue';
import PartnerRakutenCvButton from '~/components/templates/_lp/PartnerRakutenTemplate/PartnerRakutenCvButton/PartnerRakutenCvButton.vue';

const { USER_STATS } = useConstants();
</script>

<template>
  <section :class="$style.service">
    <PartnerRakutenSectionHeading
      heading="サービスについて"
      heading-en="SERVICE"
      :class="$style.service__heading"
    />

    <p :class="[$style.service__description, $style.description]">
      「オカネコ」は<br />
      <em :class="$style.description__strong"> 3ステップ</em
      >でお金の悩みを解決できます
    </p>

    <ul :class="[$style.service__list, $style.list]">
      <li :class="[$style.list__item, $style.item]">
        <h3 :class="$style.item__heading">家計診断を受ける</h3>
        <p :class="$style.item__headingDescription">
          <em :class="$style.item__strong">3分</em>で結果がわかります
        </p>
        <img src="./icon-number-01.svg" alt="01" :class="$style.item__number" />
        <img
          src="./service-image-01.png"
          alt="サービスのイメージ"
          :class="$style.item__image"
        />
        <ul :class="$style.item__descriptionList">
          <li>
            <div :class="$style.descriptionList__item">
              <CheckMarkOutlineIcon
                :class="$style.descriptionListItem__icon"
              /><span :class="$style.descriptionListItem__text"
                >質問に答えていくだけ、3分で完了</span
              >
            </div>
          </li>
          <li>
            <div :class="$style.descriptionList__item">
              <CheckMarkOutlineIcon
                :class="$style.descriptionListItem__icon"
              /><span :class="$style.descriptionListItem__text"
                >その場で結果の確認やシェアが可能</span
              >
            </div>
          </li>
          <li>
            <div :class="$style.descriptionList__item">
              <CheckMarkOutlineIcon
                :class="$style.descriptionListItem__icon"
              /><span :class="$style.descriptionListItem__text"
                >診断は匿名でうけられるので安心</span
              >
            </div>
          </li>
        </ul>
      </li>

      <li :class="[$style.list__item, $style.item]">
        <h3 :class="$style.item__heading">診断結果にプロがコメント</h3>
        <p :class="$style.item__headingDescription">
          <em :class="$style.item__strong">1~2日ほど</em>で届きます
        </p>
        <img src="./icon-number-02.svg" alt="02" :class="$style.item__number" />
        <img
          src="./service-image-02.png"
          alt="サービスのイメージ"
          :class="$style.item__image"
        />
        <ul :class="$style.item__descriptionList">
          <li>
            <div :class="$style.descriptionList__item">
              <CheckMarkOutlineIcon
                :class="$style.descriptionListItem__icon"
              /><span :class="$style.descriptionListItem__text"
                >結果を見てプロが無料でアドバイス</span
              >
            </div>
          </li>
          <li>
            <div :class="$style.descriptionList__item">
              <CheckMarkOutlineIcon
                :class="$style.descriptionListItem__icon"
              /><span :class="$style.descriptionListItem__text"
                >プロは楽天証券認定のIFA（※）</span
              >
            </div>
          </li>
          <li>
            <div :class="$style.descriptionList__item">
              <CheckMarkOutlineIcon
                :class="$style.descriptionListItem__icon"
              /><span :class="$style.descriptionListItem__text"
                >IFAの得意分野やクチコミなどのプロフィールも確認できて安心</span
              >
            </div>
          </li>
        </ul>
        <p :class="$style.descriptionListItem__annotation">
          ※IFA：独立系ファイナンシャルアドバイザー
        </p>
      </li>

      <li :class="[$style.list__item, $style.item]">
        <h3 :class="$style.item__heading" style="line-height: 1.3">
          楽天証券認定のIFAに<br />チャットで相談
        </h3>
        <img src="./icon-number-03.svg" alt="03" :class="$style.item__number" />
        <img
          src="./service-image-03.png"
          alt="サービスのイメージ"
          :class="$style.item__image"
        />
        <ul :class="$style.item__descriptionList">
          <li>
            <div :class="$style.descriptionList__item">
              <CheckMarkOutlineIcon
                :class="$style.descriptionListItem__icon"
              /><span :class="$style.descriptionListItem__text"
                >楽天証券認定のIFAに無料で相談</span
              >
            </div>
          </li>
          <li>
            <div :class="$style.descriptionList__item">
              <CheckMarkOutlineIcon
                :class="$style.descriptionListItem__icon"
              /><span :class="$style.descriptionListItem__text"
                >チャットなので、好きなタイミングで相談し放題</span
              >
            </div>
          </li>
        </ul>
      </li>
    </ul>
    <div :class="$style.service__notice">&#8251;画像はイメージです</div>

    <footer :class="[$style.service__footer, $style.footer]">
      <div :class="$style.footerContainer">
        <div :class="$style.footerButtonContainer">
          <p :class="$style.buttonDecorativeText">
            累計ユーザー数<span :class="$style.userCount">{{
              USER_STATS.countIn10K
            }}</span
            >万人突破
          </p>
          <PartnerRakutenCvButton />
        </div>
      </div>
    </footer>
  </section>
</template>

<style lang="scss" module>
.service {
  padding: 40px 0 0;

  @include desktop-only {
    padding: 90px 0 0;
  }

  &__description {
    margin-top: 32px;
    padding: 0 16px;
    text-align: justify;

    @include tablet-upper {
      text-align: center;
    }
  }

  &__list {
    max-width: 1128px;
    margin: 64px auto 0;
  }

  &__notice {
    width: 100%;
    text-align: end;
    max-width: 1128px;
    padding: 8px 16px;
    margin: auto;
  }

  &__button {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    padding: 0 36px;

    @include desktop-only {
      margin-top: 80px;
    }
  }

  &__footer {
    &:nth-child(n + 2) {
      margin-top: 28px;

      @include tablet-upper {
        margin-top: 92px;
      }
    }
  }
}

.description {
  font-size: 14px;
  font-weight: bold;
  text-align: center;

  @include tablet-upper {
    font-size: 20px;
  }

  &__strong {
    color: #ff5e00;
    font-weight: bold;
  }
}

.list {
  display: grid;
  gap: 60px;
  padding: 0 16px;

  @include desktop-only {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
}

.item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 58px 16px 32px;
  border-radius: 10px;
  box-shadow: $shadow-20;

  @include desktop-only {
    padding: 80px 4px 32px;
  }

  &__number {
    position: absolute;
    top: -22px;
    left: 50%;
    transform: translateX(-50%);
  }

  &__image {
    display: block;
    width: 180px;
    margin-top: 26px;
    filter: drop-shadow(0px 10px 20px $color-shadow);

    @include desktop-only {
      width: 200px;
    }
  }

  &__heading {
    font-size: 24px;
    text-align: center;
  }

  &__headingDescription {
    font-size: 16px;
    font-weight: bold;
  }

  &__strong {
    color: #ff5e00;
    font-weight: bold;
  }
}

.descriptionList {
  &__item {
    display: inline-flex;
    align-items: center;
    justify-content: left;
    width: 288px;
    margin-top: 24px;
    padding: 12px;
    border: 2px solid $color-border-high-emphasis;
    border-radius: 50px;
  }
}
.descriptionListItem {
  &__icon {
    display: inline-block;
    flex-shrink: 0;
    height: 24px;
    width: 24px;
    color: $color-text-and-object-accent-primary;
  }

  &__text {
    display: inline-block;
    margin-left: 5px;
    font-size: 14px;
    font-weight: bold;
  }

  &__annotation {
    margin-top: 12px;
    width: 288px;
    text-align: left;
    font-size: 12px;
  }
}

.footer {
  background-color: $color-surface-accent-primary;
  color: $color-text-and-object-high-emphasis-inverse;
  width: 100%;

  @include desktop-only {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.footerContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 0;

  @include desktop-only {
    padding: 24px 0 36px;
  }
}

.footerButtonContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.buttonDecorativeText {
  font-size: 15px;
  font-weight: 600;
}

.userCount {
  font-size: 30px;
}
</style>
